export class Search {
    constructor(inputSelector, resultSelector) {
        this.$refreshSearchInputs = $(inputSelector); // Inputs triggering search
        this.$resultContainer = $(resultSelector);    // Results container
    }

    init() {
        this.$refreshSearchInputs.change((e) => this.handleChange(e)); // Listen for changes
    }

    handleChange(e) {
        let $input = $(e.currentTarget);
        let $form = $input.closest("form");

        // Check for Year and Month dropdowns for specific functionality
        if ($form.find('select[name="y"]').length > 0) {
            let yearValue = $form.find('select[name="y"]').val();
            let monthValue = $form.find('select[name="m"]').val();

            // Reset Month dropdown if Year is deselected
            if (yearValue === "") {
                $form.find('select[name="m"]').val('');

                // Trigger a search when Year is deselected
                this.submitForm($form);
                return; // Prevent further checks
            }

            // Prevent submission if only a Month is selected without a Year
            if (monthValue !== "" && yearValue === "") {
                return; // Block submission if invalid state
            }
        }

        // Submit the form for all other cases
        this.submitForm($form);
    }

    submitForm($form) {
        let data = $form.serialize();              // Serialize form data
        let updateUrl = $form.attr("action");      // Form action URL

        // Additional Year/Month validation for forms with these fields
        if ($form.find('select[name="y"]').length > 0) {
            let yearValue = $form.find('select[name="y"]').val();
            let monthValue = $form.find('select[name="m"]').val();

            if (yearValue === "" && monthValue !== "") {
                return; // Prevent submission if Month is selected without Year
            }
        }

        // Perform AJAX request
        $.ajax({
            url: updateUrl,
            type: "POST",
            data: data,
            success: (data, textStatus, jqXHR) => {
                this.$resultContainer.html(data); // Update results container
            },
            error: (resp) => {
                console.error('Error submitting form:', resp); // Handle errors
            }
        });
    }
}



// WEBPACK FOOTER //
// ./frontend/js/components/ost.search.js